<template>
  <nav
    class="flex xl:px-32 lg:px-20 md:px-12 px-5 py-4 gap-10 justify-between items-center border-b border-divider sticky top-0 bg-background z-20"
  >
    <div class="flex lg:flex-col lg:items- items-center cursor-pointer gap-2">
      <ion-icon
        name="menu-sharp"
        class="md:hidden text-2xl text-foreground"
        @click="toggleSideDrawer"
      ></ion-icon>
      <h1 class="text-md md:text-2xl font-black text-primary whitespace-nowrap">
        MEME MACHINE
      </h1>
    </div>

    <!-- Drawer -->
    <div
      v-if="sideDrawerOpen"
      class="fixed top-0 left-0 drop-shadow-md z-50 w-64"
    >
      <div
        class="flex flex-col p-4 bg-background transition-all duration-300 ease-in-out transform"
        :class="{
          'translate-x-full': !sideDrawerOpen,
          'translate-x-0': sideDrawerOpen,
        }"
      >
        <!-- Side drawer content goes here -->
        <div class="flex justify-between">
          <div></div>
          <ion-icon
            name="close"
            class="text-3xl text-foreground"
            @click="toggleSideDrawer"
          ></ion-icon>
        </div>
        <MobileNav :mobile="sideDrawerOpen" />
      </div>
    </div>

    <!-- Mobile Nav -->
    <div class="flex gap-1 md:hidden">
      <NavConnectButton />
      <button>
        <ion-icon
          name="sunny-sharp"
          class="text-primary border border-1 border-primary p-2 transition duration-300 hover:bg-primary hover:text-white"
          v-if="currentTheme === 'light'"
          @click="switchTheme('dark')"
        ></ion-icon>
        <ion-icon
          name="moon-sharp"
          class="text-primary border border-1 border-primary p-2 transition duration-300 hover:bg-primary hover:text-white"
          v-if="currentTheme === 'dark'"
          @click="switchTheme('light')"
        ></ion-icon>
      </button>
    </div>

    <!-- Desktop Nav -->
    <div class="hidden md:flex shrink basis-96">
      <div
        class="flex gap-4 border border-1 border-divider rounded-l-full px-3 py-2 outline-primary outline-1 hover:outline focus-within:outline w-full z-10"
      >
        <input
          class="outline-none text-sm w-full bg-background pr-1 text-foreground"
          placeholder="Search..."
          v-model="searchMessage"
          @keyup.enter="triggerSearch"
        />
      </div>
      <button
        class="group rounded-r-full border-1 border-divider px-4 bg-hover hover:bg-divider transition duration-300"
        @click="triggerSearch"
      >
        <IosSearchIcon
          w="24"
          h="24"
          class="fill-foreground group-hover:fill-background"
        />
      </button>
    </div>
    <div class="hidden md:flex gap-8">
      <NavConnectButton />
      <div class="flex gap-3">
        <button class="border-r-2 pr-3 border-primary">
          <IosSunnyIcon
            w="36"
            h="36"
            :class="{
              'fill-primary': currentTheme === 'light',
              'fill-foreground': currentTheme === 'dark',
            }"
            @click="switchTheme('light')"
          /></button
        ><button>
          <IosMoonIcon
            w="30"
            h="30"
            :class="{
              'fill-primary': currentTheme === 'dark',
              'fill-foreground': currentTheme === 'light',
            }"
            @click="switchTheme('dark')"
          />
        </button>
      </div>
    </div>
  </nav>
</template>
<script>
import IosSearchIcon from "vue-ionicons/dist/ios-search.vue";
import IosSunnyIcon from "vue-ionicons/dist/ios-sunny.vue";
import IosMoonIcon from "vue-ionicons/dist/ios-moon.vue";
import NavConnectButton from "./NavConnectButton.vue";
import MobileNav from "../sidenav/SideNav.vue";

export default {
  components: {
    IosSearchIcon,
    IosSunnyIcon,
    IosMoonIcon,
    NavConnectButton,
    MobileNav,
  },
  data() {
    return {
      sideDrawerOpen: false,
    };
  },
  methods: {
    switchTheme(theme) {
      this.$store.dispatch("SwitchTheme", theme);
    },
    toggleSideDrawer() {
      this.sideDrawerOpen = !this.sideDrawerOpen;
    },
    triggerSearch() {
      this.$store.dispatch("ChangeActiveLink", "Search");
      this.$store.dispatch("ChangeSearchMessage", this.searchMessage);
    },
  },
  computed: {
    currentTheme() {
      return this.$store.state.theme;
    },
  },
};
</script>
